export default __webpack_public_path__ + "static/0025-33c690b30e749fdc38f3e60736ecdf87.png";